"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeExperiment = _interopRequireDefault(require("hublabs-experiments/helpers/makeExperiment"));

var _default = (0, _makeExperiment.default)({
  name: 'CrmPrecacheExperiment',
  allowAutoExposureLogging: false,
  setupParams: function setupParams(params, _ref) {
    var flipCoin = _ref.flipCoin;
    params.set('shouldPrecache', flipCoin());
  }
});

exports.default = _default;
module.exports = exports.default;